import { dateTimeFormat } from '@nike/i18n-core';
import getWebShellClientLocale from '@nike/shop-apis/utils/get-webshellclient-locale';

/**
 * @description localizes and formats given min and max iso date strings
 *
 * @param {object} params - named parameters
 * @param {string} params.minDate - minimum date as iso string
 * @param {string} params.maxDate - maximum date as iso string
 * @param {string} params.timeZone - timezone of latest arrival date
 * @returns {{ formattedMaxDate: string }} - localized and formatted dates
 */
var formatDates = function formatDates(_ref) {
  var maxDate = _ref.maxDate,
    timeZone = _ref.timeZone;
  var language = getWebShellClientLocale().hreflang;
  var dateProps = {
    month: 'short',
    day: 'numeric',
    weekday: 'short',
    timeZone: timeZone
  };
  var finalMaxDate = maxDate && new Date(maxDate);
  return {
    formattedMaxDate: maxDate && dateTimeFormat(language, finalMaxDate, dateProps)
  };
};
export default formatDates;